module.exports = __webpack_public_path__ + "static/media/t-shirt.14657baf.jpg";